import React from 'react'

//styles
import "./ProductClientView.css"

//components
import ProductList from '../productList/ProductList'
import ProductFilters from '../productFilters/ProductFilters';
import SideBarComponent from '../sideBarComponent/SideBarComponent';
import { Button } from 'antd';
import { FaFilter } from 'react-icons/fa6';

const ProductClientView = () => {
    const [loading, setLoading] = React.useState<boolean>(false);
    const [filterCategory, setFilterCategory] = React.useState<string[]>([]);
    const [filterFranchise, setFilterFranchise] = React.useState<string[]>([]);
    const [filterStatus, setFilterStatus] = React.useState<string[]>([]);
    const [total, setTotal] = React.useState<number>(0);


    const [openResponsiveFilters, setOpenResponsiveFilters] = React.useState<boolean>(false);

  return (
    <div className='ProductClientView-component'>

        <SideBarComponent open={openResponsiveFilters} setOpen={setOpenResponsiveFilters}>
            <ProductFilters 
            filterCategory={filterCategory}
            filterFranchises={filterFranchise}
            filterStatus={filterStatus}
            setFilterCategory={setFilterCategory}
            setFilterFranchises={setFilterFranchise}
            setFilterStatus={setFilterStatus}
            loadingProducts={loading} />   
        </SideBarComponent>

        <div className='ProductClientView-filters'>
            <ProductFilters 
            filterCategory={filterCategory}
            filterFranchises={filterFranchise}
            filterStatus={filterStatus}
            setFilterCategory={setFilterCategory}
            setFilterFranchises={setFilterFranchise}
            setFilterStatus={setFilterStatus}
            loadingProducts={loading} />        
        </div>

        <div className='ProductClientView-body'>
            <div className='ProductClientView-info'>
                <Button className='ProductClientView-filterButton' type='primary' onClick={()=>{
                    setOpenResponsiveFilters(true)
                }}>
                    <FaFilter />
                </Button>
                {total!=0 && <span className='ProductClientView-info-text'>{total} productos</span>}
            </div>
            <div className='ProductClientView-products'>
                <ProductList 
                categories={filterCategory}
                franchise={filterFranchise}
                status={filterStatus} 
                setTotal={setTotal}
                loading={loading} setLoading={setLoading} />
            </div>
        </div>
        
    </div>
  )
}

export default ProductClientView